function SummaryStats({ wellName, stats, bblPerIn, numHaulsRaw, waterRateStats }) {
  const fmt = (val) => {
    if (bblPerIn > 0) return `${(val * bblPerIn).toFixed(1)} bbl`;
    return `${val.toFixed(1)} in`;
  };

  if (!stats) {
    return (
      <div className="stats-row">
        <div className="stat-tile">
          <div className="stat-label">{wellName}</div>
          <div className="stat-value" style={{ fontSize: 16 }}>No hauls match current filter</div>
        </div>
      </div>
    );
  }

  return (
    <div className="stats-row">
      <div className="stat-tile">
        <div className="stat-label">Total hauls</div>
        <div className="stat-value">{stats.totalHauls}</div>
        {stats.totalHauls !== numHaulsRaw && (
          <div className="stat-sub">{numHaulsRaw} before filter</div>
        )}
      </div>
      <div className="stat-tile">
        <div className="stat-label">Avg haul volume</div>
        <div className="stat-value">{fmt(stats.avgHaulFt)}</div>
        <div className="stat-sub">median {fmt(stats.medianHaulFt)}</div>
      </div>
      <div className="stat-tile">
        <div className="stat-label">Min / Max</div>
        <div className="stat-value" style={{ fontSize: 18 }}>
          {fmt(stats.minHaulFt)} — {fmt(stats.maxHaulFt)}
        </div>
      </div>
      <div className="stat-tile">
        <div className="stat-label">Total hauled</div>
        <div className="stat-value">{fmt(stats.totalHauledFt)}</div>
      </div>
      {waterRateStats && (
        <>
          <div className="stat-tile">
            <div className="stat-label">Water Rate (slope)</div>
            <div className="stat-value">
              {waterRateStats.avgWaterRate != null
                ? `${waterRateStats.avgWaterRate.toFixed(1)} bwpd` : '—'}
            </div>
            {waterRateStats.count > 0 && (
              <div className="stat-sub">from {waterRateStats.count} fills</div>
            )}
          </div>
          <div className="stat-tile">
            <div className="stat-label">Avg Gas Rate</div>
            <div className="stat-value">
              {waterRateStats.avgGasRate != null
                ? `${waterRateStats.avgGasRate.toFixed(1)} mcf/d` : '—'}
            </div>
          </div>
          <div className="stat-tile">
            <div className="stat-label">WGR (derived)</div>
            <div className="stat-value">
              {waterRateStats.avgWgr != null
                ? `${waterRateStats.avgWgr.toFixed(3)}` : '—'}
            </div>
            {waterRateStats.avgWgr != null && (
              <div className="stat-sub">bbl/mcf</div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default SummaryStats;
